import React, { forwardRef, useMemo } from "react";
import classNames from "classnames";
import { animated, useSpring } from "@react-spring/web";
import { BaseProps } from "../common/BaseProps";

export interface FadeInZoomProps extends BaseProps {
  in?: boolean;
  willEnter?: () => void;
  willLeave?: () => void;
}


export default function FadeInZoom(props: FadeInZoomProps, ref) {
  const { className, children, in: inProp, ...other } = props;
  const styleClass = classNames("bm-FadeInZoom", className);

  const styles = useSpring({
    from: {
      opacity: 0,
      scale: 0
    },
    to: {
      opacity: 1,
      scale: 1
    },
    reverse: !props.in
  });

  return (
    <animated.div className={styleClass} style={styles} ref={ref}>
      {children}
    </animated.div>
  );
}

const FadeInZoomRef = forwardRef(FadeInZoom);

export { FadeInZoomRef };
